/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_SubtitleInputs */

const en_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn commissions by referring new sellers to SSC.`)
};

const es_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana comisiones al referir nuevos vendedores a SSC.`)
};

const fr_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagnez des commissions en parrainant de nouveaux vendeurs sur SSC.`)
};

const de_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene Provisionen, indem du neue Verkäufer an SSC vermittelst.`)
};

const ja_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSCに新しい出品者を紹介して紹介料を獲得しましょう。`)
};

const zh_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐新卖家加入 SSC 赚取佣金。`)
};

const ar_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربح عمولات عن طريق إحالة بائعين جدد إلى SSC.`)
};

const id_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan komisi dengan merujuk penjual baru ke SSC.`)
};

const it_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guadagna commissioni invitando nuovi venditori su SSC.`)
};

const ru_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарабатывайте комиссионные, привлекая новых продавцов в SSC.`)
};

const pt_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe comissões indicando novos vendedores para a SSC.`)
};

const ko_affiliate_subtitle = /** @type {(inputs: Affiliate_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 판매자를 SSC에 추천하고 수수료를 받으세요.`)
};

/**
* | output |
* | --- |
* | "Earn commissions by referring new sellers to SSC." |
*
* @param {Affiliate_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_subtitle = /** @type {((inputs?: Affiliate_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_subtitle(inputs)
	if (locale === "es") return es_affiliate_subtitle(inputs)
	if (locale === "fr") return fr_affiliate_subtitle(inputs)
	if (locale === "de") return de_affiliate_subtitle(inputs)
	if (locale === "ja") return ja_affiliate_subtitle(inputs)
	if (locale === "zh") return zh_affiliate_subtitle(inputs)
	if (locale === "ar") return ar_affiliate_subtitle(inputs)
	if (locale === "id") return id_affiliate_subtitle(inputs)
	if (locale === "it") return it_affiliate_subtitle(inputs)
	if (locale === "ru") return ru_affiliate_subtitle(inputs)
	if (locale === "pt") return pt_affiliate_subtitle(inputs)
	return ko_affiliate_subtitle(inputs)
});